import { useRef } from 'react';
import { formateNumber } from '../../../utils/date-utils/formatters';

export const SubTaxCalculation = ({
  title,
  counter,
}: {
  title: string;
  counter: number;
}) => {
  const counterRef = useRef(null);
  return (
    <>
      <div className="text-s-14 text-left">{title}</div>
      <div className="text-s-14" ref={counterRef}>
        {'₹' + formateNumber(counter)}
      </div>
    </>
  );
};
